import { render, staticRenderFns } from "./AssessmentHome.vue?vue&type=template&id=6d913e47&scoped=true&"
import script from "./AssessmentHome.vue?vue&type=script&lang=js&"
export * from "./AssessmentHome.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentHome.vue?vue&type=style&index=0&id=6d913e47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d913e47",
  null
  
)

export default component.exports